// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updatePin = (state, action) => action.pin;

const resetPin = () => getDefaultState().pin;

export default (state = getDefaultState().pin, action) => {

    const actionTypes = {
        [actions.UPDATE_PART_COVERAGE_SEARCH_PIN]: updatePin,
        [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetPin,
        [actions.RESET_PART_COVERAGE_SEARCH_ADDITIONAL_INFORMATION]: resetPin
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/pin.js